import React from "react";
import { CircularProgress } from "@mui/material";
import clsx from "clsx";

/* eslint-disable-next-line */
export interface SimpleSpinnerProps {
  size?: number;
  className?: any;
}

export function Spinner({ className, size, ...rest }: SimpleSpinnerProps) {
  return (
    <CircularProgress
      {...rest}
      className={clsx("", className)}
      size={size ? size : 24}
      color="inherit"
    />
  );
}

export default Spinner;
